import React from 'react';
import database from '../../assets/blog/database.png';
import MainLayout from '../../layout/MainLayout';

const blogs = [
    {
        image: database,
        title: 'Relational Royalty vs. NoSQL Nomads: Choosing the Right Database in a Data-Driven World',
        date: 'January 26, 2024',

        readMore: 'https://www.linkedin.com/pulse/relational-royalty-vs-nosql-nomads-choosing-right-database-shanto-ylktc/?trackingId=3PaIqS1LT8CFHgzzAXnu1w%3D%3D'

    },

];
const Blog = () => {
    return (
        <MainLayout>
            <h2><span className='text-blue-500'>B</span>log</h2>
            <hr className="my-4" />

            <div className="grid gap-8 lg:grid-cols-2">
                {blogs.map((blog, index) => (
                    <div key={index} className="p-2 border border-gray-200 rounded-lg shadow-lg">
                        <h4 className=" text-xl text-blue-500 tracking-tight">{blog.title}</h4>
                        <p className='text-xs '> <span className='border border-blue-300'>{blog.date}</span></p>
                        <img className="rounded-t-lg" src={blog.image} alt={blog.title} />
                        <a className='text-blue-600 text-right block mt-3' href={blog.readMore} rel='noreferrer' target='_blank'>read blog .....</a>

                    </div>
                ))}
            </div>
        </MainLayout>
    );
};

export default Blog;